<template>
  <div class="modal-upgrade popup-wrapper" @click.self="onClose" :class="{active}">
    <div class="bg" @click="onClose"></div>

    <div class="popup">
      <div class="close" @click="onClose">
        <i class="material-icons">close</i>
      </div>

      <div class="container">
        <div class="main-title">Change the team’s manager</div>

        <div class="inner">
          Choose a member to make manager:
          <br>
          <br>
          <div class="select-dropdown" :class="{active: open}" ref="manager">
            <div class="current" @click="toggle" :class="{placeholder: !selected}">
              <span v-show="!selected">Select a team member</span>
              <span v-if="selected">{{ selected.email }}</span>
              <i class="material-icons">keyboard_arrow_down</i>
            </div>

            <div class="dropdown">
              <a class="item" v-for="item in items" :key="item.id" @click="handleSelect(item)">
                {{ item.email }}
              </a>
            </div>
          </div>
          <br>
          <br>
          <br>
          <div class="hint">
            By changing the manager role to another member, you are passing the responsibility and permission to access/manage this teams’ members and billing details. You will no longer be able to see or manage team.
          </div>

          <a class="btn primary medium" @click="handleSubmit">Save new team manager</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { findAncestor } from '../../utils/helper';

export default {
  name: 'modal-team-manager',
  props: {
    active: Boolean,
    onSubmit: Function,
    onClose: Function,
  },
  data() {
    return {
      open: false,
      selected: null,
      items: [
        {
          id: 1,
          email: 'longprao@gmail.com',
        },
        {
          id: 2,
          email: 'jamison@collarbone.com',
        },
        {
          id: 3,
          email: 'a@b.com',
        },
      ],
    };
  },
  created() {
    document.addEventListener('click', this.clickEvent);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.clickEvent);
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
    handleSelect(item) {
      this.selected = item;
      this.open = false;
    },
    handleSubmit() {
      if (this.selected) {
        this.onSubmit(this.selected);
      }
    },
    clickEvent(e) {
      if (this.$refs.manager !== findAncestor(e.target, 'select-dropdown')) {
        this.open = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../styles/team';
</style>
